export enum MovementMonitoringType {
	QuadkeyCollection,
	MonitoredNidSite,
}
